import { motion } from "framer-motion";

export default function Preview() {
  return (
    <section
      data-testid="preview-section"
      className="py-24 md:py-36 px-6 md:px-12 bg-cream"
    >
      <div className="max-w-[1200px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
        <div className="md:col-span-6 relative flex items-center justify-center min-h-[420px]">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.45 }}
            className="relative -rotate-2"
            style={{ filter: "drop-shadow(0 25px 40px rgba(31,29,27,0.16))" }}
          >
            <img
              src="/workbook/p01.jpg"
              alt="Capa do workbook"
              className="w-[280px] sm:w-[340px] md:w-[380px] h-auto border border-line"
              data-testid="preview-image-main"
            />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, scale: 0.85 }}
            whileInView={{ opacity: 1, scale: 1, rotate: 6 }}
            viewport={{ once: true }}
            transition={{ duration: 0.45, delay: 0.12 }}
            className="absolute bottom-2 -right-2 md:-right-4"
            style={{ filter: "drop-shadow(0 12px 24px rgba(31,29,27,0.16))" }}
          >
            <img
              src="/workbook/p05.jpg"
              alt="Página interior"
              className="w-28 md:w-40 h-auto border border-line"
            />
          </motion.div>
        </div>

        <div className="md:col-span-6 md:pl-10">
          <span className="section-num mb-6 inline-flex">04 · Lá dentro</span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-ink leading-[1.02] mt-2 mb-10">
            45 páginas
            <br />
            para te <span className="font-serif-display text-orange normal-case lowercase">ouvires.</span>
          </h2>
          <ul className="space-y-4">
            {[
              ["10 ensaios", "curtos, íntimos, sem floreados"],
              ["10 exercícios", "para escreveres, riscares e voltares atrás"],
              ["1 compromisso final", "a tua promessa, em palavras tuas"],
              ["PDF pronto a imprimir", "em A4, para escreveres à mão"],
            ].map(([title, desc], i) => (
              <motion.li
                key={i}
                initial={{ opacity: 0, x: -16 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-30px" }}
                transition={{ duration: 0.25, delay: i * 0.04 }}
                className="flex items-baseline gap-3 pb-4 border-b border-line"
              >
                <span className="text-orange text-base flex-shrink-0">✦</span>
                <span className="text-base md:text-lg text-ink">
                  <strong className="font-medium">{title}</strong>
                  <span className="text-ink-soft"> — {desc}</span>
                </span>
              </motion.li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
